import React from 'react';
import AutomationCard from '../engine/FormBuilderAutomationCardEngine';
import { Container } from './FormBuilderStatusesView';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components/macro';
import SearchEngine from '../engine/SearchEngine';
import Button from '../Button';
import useTranslations from '../../hooks/useTranslations';
import { ACTIVE_VIEW } from '../engine/FormBuilderAutomationsEngine';
import Image from '../Image';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';

const TopContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const EmptyState = styled.div`
  margin: auto;
  text-align: center;
`;

const StaticContent = styled.div`
  display: flex;
`;

const ButtonsContainer = styled.div`
  margin-left: auto;
`;

const FormBuilderAutomationsView = props => {
  const t = useTranslations();

  return (
    <Container>
      <TopContainer>
        <SearchEngine onSearch={props.onSearch} />
        <ButtonsContainer>
          <Button
            startIcon={<Image src="wand.png" width={24} />}
            onClick={() => props.setActiveView(ACTIVE_VIEW.CUSTOM_BUTTONS)}
            variant="outlined"
          >
            {t('automaions.custom_buttons.add')}
          </Button>
          <Button
            startIcon={<LibraryAddCheckIcon width={24} />}
            onClick={() => props.setActiveView(ACTIVE_VIEW.BULK_ACTIONS)}
            variant="outlined"
          >
            {t('automations.bulk_actions.add')}
          </Button>
          <Button onClick={props.onAddNewAutomation}>
            {t('automaions.add')}
          </Button>
        </ButtonsContainer>
      </TopContainer>

      <StaticContent>
        {props.staticAutomations &&
          props.staticAutomations.map(a => (
            <AutomationCard
              staticCard
              automationData={a}
              key={a.internalId}
              update={payload =>
                props.dispatch({
                  type: 'update_single_automation',
                  payload,
                  id: a.internalId
                })
              }
            />
          ))}
      </StaticContent>

      {props.automations && !!props.automations.length ? (
        <DragDropContext onDragEnd={props.onDragEnd}>
          <Droppable droppableId="droppable">
            {provided => (
              <>
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {props.automations.map(a => (
                    <AutomationCard
                      automationData={a}
                      key={a.internalId}
                      statuses={props.statuses}
                      onEdit={() => props.openWizard(a)}
                      onDelete={() => props.onAutomationDelete(a.internalId)}
                      update={(payload, showSnackbar) => {
                        if (showSnackbar) {
                          props.showSnackbarOnSave.current = true;
                        }
                        props.dispatch({
                          type: 'update_single_automation',
                          payload,
                          id: a.internalId
                        });
                      }}
                    />
                  ))}
                </div>
                {provided.placeholder}
              </>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        <EmptyState>
          {t(`automaions.empty${props.filter ? '.filter' : ''}`)}
        </EmptyState>
      )}
    </Container>
  );
};

export default FormBuilderAutomationsView;
